import localFont from 'next/font/local';

export const saudiRiyyal = localFont({
  src: './saudi_riyal.ttf',
  display: 'swap',
});

export const SaudiRiyal = ({ className }: { className?: string }) => {
  return (
    <span className={`${saudiRiyyal.className} p-0 text-inherit ${className}`}>
      &#xE900;
    </span>
  );
};
